export const FORGOT_FAILED = "FORGOT_FAILED";
export const FORGOT_REQUEST = "FORGOT_REQUEST";
export const FORGOT_SUCCESS = "FORGOT_SUCCESS";

export const FIND_MAIL_FAILED = "FIND_MAIL_FAILED";
export const FIND_MAIL_REQUEST = "FIND_MAIL_REQUEST";
export const FIND_MAIL_SUCCESS = "FIND_MAIL_SUCCESS";
export const FORGOT_LOADING = "FORGOT_LOADING";
